import React from "react";
import "./VirasatV2InputComponents.scss"
import PhoneInput from 'react-phone-number-input'

const PhoneInputComponent = ({ label, value, onChange, placeholder, required, error, errorText, disable }) => {
    return (
        <div className="VirasatV2InputComponents-VirasatV2Default">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`VirasatV2InputComponents-VirasatV2Default-container ${error ? "error" : disable ? "disable" : ""}`}>
                <PhoneInput
                    defaultCountry="GB"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className="VirasatV2InputComponents-VirasatV2Default-container-input"
                    disabled={disable ?? false}

                />
            </div>
            {errorText !== "" && < div className="input-error-text">
                {errorText}
            </div>}
        </div>
    )
}
export default PhoneInputComponent